import { Action } from '@ngrx/store';
import { CampaignSummaryResult, PaginationInfo, CampaignListingRequestInfo, SortingInfo } from '../campaign';

export enum ScheduledCampaignActionTypes {
    loadCampaigns = '[Scheduled Campaigns] Load campaigns',
    loadCampaignsSuccess = '[Scheduled Campaigns] Load campaigns success',
    loadCampaignsFail = '[Scheduled Campaigns] Load campaigns fail',
    setPaginationInfo = '[Scheduled Campaigns] Set pagination info',
    setSortingInfo = '[Scheduled Campaigns] Set sorting info',
    setIsloadingCampaigns = '[Scheduled Campaigns] loading'
}

export class LoadCampaigns implements Action {
    readonly type = ScheduledCampaignActionTypes.loadCampaigns;
    constructor(public payload: CampaignListingRequestInfo) { }
}

export class LoadCampaignsSuccess implements Action {
    readonly type = ScheduledCampaignActionTypes.loadCampaignsSuccess;
    constructor(public payload: CampaignSummaryResult) { }
}

export class LoadCampaignsFail implements Action {
    readonly type = ScheduledCampaignActionTypes.loadCampaignsFail;
    constructor(public payload: string) { }
}

export class SetIsLoadingCampaigns implements Action {
    readonly type = ScheduledCampaignActionTypes.setIsloadingCampaigns;
}

export class SetPaginationInfo implements Action {
    readonly type = ScheduledCampaignActionTypes.setPaginationInfo;
    constructor(public payload: PaginationInfo) { }
}

export class SetSortingInfo implements Action {
    readonly type = ScheduledCampaignActionTypes.setSortingInfo;
    constructor(public payload: SortingInfo) { }
}

export type ScheduledCampaignActions = LoadCampaigns
    | LoadCampaignsSuccess
    | LoadCampaignsFail
    | SetIsLoadingCampaigns
    | SetSortingInfo
    | SetPaginationInfo;
